import { Tag } from './Tag';

interface DataPoint {
  displayValue: string;
}

interface Period {
  displayName: string;
}

interface Aspect {
  displayName: string;
  dataPoints: DataPoint[];
  displayStyles: string[] | null;
}

export interface Chart {
  footNote: string | null;
  reference: string;
  unitText: string;
  periods: Period[];
  aspects: Aspect[];
}

export interface PageComponent {
  title: string;
  body: string;
  modifiedDate: string;
  parent: string | null;
  tags: Tag[];
  charts: Chart[] | null;
}

export enum PageComponentTagId {
  BUSINESS_DESCRIPTION = 'component/company_business_description',
  CREDIT_VIEW = 'component/company_credit_view',
  RISKS_CATALYSTS = 'component/company_risks_catalysts',
  CAPITAL_STRUCTURE = 'component/company_cap_structure',
  KEY_METRICS = 'component/company_key_metrics',
  OPERATING_CONDITION = 'component/company_operating_condition',
  FINANCIAL_CONDITION = 'component/company_financial_condition',
  SIZE_GEOGRAPHY = 'component/company_size_geography',
  CORPORATE_STRUCTURE = 'component/company_corp_structure',
  RELATIVE_VALUE = 'component/company_relative_value',
  ESG = 'component/company_ESG',
  FLEX1 = 'component/company_flex1',
  MNA = 'component/company_MnA',
  LITIGATION = 'component/company_litigation',
  MANAGEMENT_COMMENTARY = 'component/company_management_commentary',
  FLEX2 = 'component/company_flex2',
  FLEX3 = 'component/company_flex3',
  LEASE_ADJUSTMENTS = 'component/company_lease_adjustments',
  COVENANTS = 'component/company_covenants',
  FLEX4 = 'component/company_flex4',
  FLEX5 = 'component/company_featured',
}

export const PageFlexComponents: PageComponentTagId[] = [
  PageComponentTagId.FLEX1,
  PageComponentTagId.FLEX2,
  PageComponentTagId.FLEX3,
  PageComponentTagId.FLEX4,
  PageComponentTagId.FLEX5,
];

export type PageComponentsMap = Partial<Record<string, PageComponent>>;
